import React from 'react'
import c1 from "../images/download (1).jpeg"
import c3 from "../images/download.jpeg"
import c4 from "../images/images (1).jpeg"
import c5 from "../images/images.jpeg"
import m1 from "../images/download (2).jpeg"
import m2 from "../images/images (7).jpeg"
import m3 from "../images/images (2).jpeg"
import m4 from "../images/images (3).jpeg"
import k1 from "../images/images (8).jpeg"
import k2 from "../images/images (9).jpeg"
import k3 from "../images/images (10).jpeg"
import k4 from "../images/images (11).jpeg"


const KiteTypes = () => {
  return (
    <>
      <div className="fancy-kites">
        <h1>Kids Fancy Kites</h1>
        <div className="fk-img">
          <img src={k1} alt="kite_img" />
          <img src={k2} alt="kite_img" />
          <img src={k3} alt="kite_img" />
          <img src={k4} alt="kite_img" />
        </div>
      </div>
      <div className="fancy-kites">
        <h1>Maanja</h1>
        <div className="fk-img">
          <img src={m1} alt="kite_img" />
          <img src={m2} alt="kite_img" />
          <img src={m3} alt="kite_img" />
          <img src={m4} alt="kite_img" />
        </div>
      </div>
      <div className="fancy-kites">
        <h1>Paper Kites</h1>
        <div className="fk-img">
          <img src={c1} alt="kite_img" />
          <img src={c3} alt="kite_img" />
          <img src={c4} alt="kite_img" />
          <img src={c5} alt="kite_img" />
        </div>
      </div>
    </>
  )
}

export default KiteTypes
